import { Sounds } from './entities';

export class PlaySoundEnvironment {
  public static getName = () => 'benzinga-play-sound';
  public static getEnvironment = (env: Record<string, Sounds>): { sounds: Sounds } => ({
    sounds: (env.sounds ?? {}) as Sounds,
  });
}
